import type { Entity, ImmutableArray } from "shelving";
import { splitEntity } from "shelving";
import { ChallengeCard } from "../challenge/ChallengeCard.js";
import { CommentCard } from "../comment/CommentCard.js";
import { GroupCard } from "../group/GroupCard.js";
import { MessageCard } from "../group/MessageCard.js";
import { ListCard } from "../list/ListCard.js";
import { NoteCard } from "../note/NoteCard.js";
import { PostCard } from "../post/PostCard.js";
import { ProfileCard } from "../profile/ProfileCard.js";
import { RewardCard } from "../reward/RewardCard.js";
import { EntityButton } from "./EntityButton.js";

export function EntityCard({ entity }: { entity: Entity }): React.ReactElement {
	const [type, id] = splitEntity(entity);
	return type === "profile" ? (
		<ProfileCard uid={id} />
	) : type === "group" ? (
		<GroupCard gid={id} />
	) : type === "challenge" ? (
		<ChallengeCard id={id} />
	) : type === "reward" ? (
		<RewardCard id={id} />
	) : type === "note" ? (
		<NoteCard id={id} />
	) : type === "list" ? (
		<ListCard id={id} />
	) : type === "post" ? (
		<PostCard id={id} />
	) : type === "comment" ? (
		<CommentCard id={id} />
	) : type === "message" ? (
		<MessageCard id={id} />
	) : (
		<EntityButton entity={entity} /> // Not every entity has an embed, so fall back to buttons.
	);
}

/** Output a list of entity cards. */
export function EntityCards({ entities, mods }: { entities: ImmutableArray<Entity>; mods?: string | undefined }): React.ReactElement | null {
	return entities.length ? (
		<section className={mods}>
			{entities.map(entity => (
				<EntityCard key={entity} entity={entity} />
			))}
		</section>
	) : null;
}
